// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1789527612484
      var cssReload = require("D:/work/code/git/platform_el/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  